/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */

import { Form, Input, UploadFile } from 'antd'
import FormItem from 'antd/lib/form/FormItem'
import {
 TSendMailBody,
 useSendEmailLeadMutation,
 useSendScheduleEmailLeadMutation,
 useSendScheduleEmailProMutation,
} from 'features/leads'
import { useSendListingEmailMutation } from 'api/baseApi'
import { useGetEmailTemplateByIdQuery } from 'features/settings'
import useAppControl from 'hooks/useAppControl'
import useAuth from 'hooks/useAuth'
import { useGlobal } from 'raducer/global'
import { FC, useEffect, useMemo, useRef, useState } from 'react'
import {
 convert2FormDataEmail,
 //  convetUrl2FileList,
} from 'components/shared/SendEmailForm/functions'
import EmailSubjectInput from 'components/shared/Common/EmailSubjectInput'
import SWToBarTag from 'components/elements/SWToBarTag/SWToBarTag'
import SWToBar from 'components/elements/SWToBar/SWToBar'
import { globalToaster } from 'components/elements/global'
import {
 inboxApi,
 useLazyGetScheduleEmailByIdQuery,
 useUpdateEmailScheduleMutation,
} from 'features/inbox'
import { queryClient } from 'lib/react-query'
import { useDispatch } from 'react-redux'
import { utils } from 'utils'
import InsufficientCredits from 'features/profile/components/InsufficientCredits'
import { TLimitReached } from 'features/profile'
import { SendWidgetProps } from '../index'
import SendWidgetLayout from '../Layout'
import EmailTextEditor from '../_components/EMailTextEditor'
import { handleSignatureContent, setProPreLoadContent } from '../functions'
import SWCCInput from '../_components/SWCCInput'
import EmailAttachmentsPopver from '../_components/EmailAttachmentsPopver'

type EmailSendWidgetProps = SendWidgetProps
export type TProLeadsSelectAll = {
 selectAll: boolean
 unSelected: any[]
 unSelectedId: any[]
 filterInfo: string
 showMoreLabel: boolean
 show: boolean
 selectedCount: number
 searchKey: string
}

const EmailSendWidget: FC<EmailSendWidgetProps> = ({
 onSendSuccess,
 mode,

 type,
 //  wFrom,
}) => {
 const { user } = useAuth()
 const [limitReached, setLimitReached] = useState<TLimitReached | null>(null)

 const initialValues: TSendMailBody = {
  to: [],
  from: user?.twilio_email,
  body: '',
  temp_attachment: [],
 }
 const d = useDispatch()

 const { global } = useGlobal()
 const { sendWidget, updateSendEmailWidget, onSuccessEmail } = useAppControl()
 const { listing_mail_content, listing_mail_subject } = global || {}
 const {
  widgetFrom,
  selectAll,
  filterInfo,
  unSelected,
  to,
  propFullInfo,
  showMoreLabel,
  extraBody,
  propertyData,
  proListingType,
  disableBody,
  customtSelectAll,
  replyData,
  forwardData,
  editData,
  hideAttachment = false,
  inboxRefetchKey,
  prefill,
 } = sendWidget || {}

 const proLeadsSelectAllInitialValues = {
  selectAll: false,
  unSelectedId: [],
  unSelected: [],
  filterInfo: '',
  showMoreLabel: false,
  show: widgetFrom === 'listing',
  selectedCount: 1,
  searchKey: '',
 }
 const [proLeadsSelectAll, setProLeadsSelectAll] = useState<
  TProLeadsSelectAll | undefined
 >(proLeadsSelectAllInitialValues)

 //  const [attachmentFile, setAttachmentFile] = useState<UploadFile[]>([])

 const [templateId, setTemplateId] = useState<any>()
 const [sign, setSign] = useState(user?.signature?.signature ?? '')
 const [selectedSign, setSelectedSign] = useState(user?.signature?.id)
 const [showCcInput, setShowCcInput] = useState(true)
 const [scheduleEmail, { isLoading: sendScheduleEmailLoading }] =
  useSendScheduleEmailLeadMutation()
 const [SendScheduleEmailPro, { isLoading: SendScheduleEmailProLoading }] =
  useSendScheduleEmailProMutation()
 const [sendEmail, { isLoading: sendEmailLoading }] = useSendEmailLeadMutation()
 const [sendlistingEmail, { isLoading: ListEmailLoading }] =
  useSendListingEmailMutation()
 const [updateEmailSchedule, { isLoading: emailScheduleLoading }] =
  useUpdateEmailScheduleMutation()
 const [getScheduleEmailById] = useLazyGetScheduleEmailByIdQuery()

 const {
  data: templateData,
  isLoading,
  isFetching,
 } = useGetEmailTemplateByIdQuery({ id: templateId }, { skip: !templateId })

 const [sendMailForm] = Form.useForm<TSendMailBody>()
 const watch = Form.useWatch([], sendMailForm)
 const totalAttachmentMb = (v?: any[]): number =>
  Number(
   utils.convertToMb(
    v?.map((i) => Number(i?.size ?? 0))?.reduce((a, b) => a + b, 0) ?? 0,
   ),
  )
 //  const attachmentCount = useMemo(
 //   () => attachmentFile.length,
 //   [attachmentFile.length],
 //  )
 const productCount = useMemo(
  () => propFullInfo?.length || 0,
  [propFullInfo?.length],
 )

 const valueToField = useMemo(() => {
  if (type === 'tag' || type === 'stage' || type === 'source') {
   return (watch?.to as any)?.map?.((i: any) => i?.id)?.join(',')
  }
  if (Array.isArray(watch?.to)) {
   return watch?.to?.join(',')
  }
  return watch?.to
 }, [widgetFrom, mode, watch])

 const isSelectAll = useMemo(() => {
  if (customtSelectAll !== undefined) {
   return customtSelectAll !== null
  }
  return selectAll ?? false
 }, [customtSelectAll, selectAll])

 const handleClickSend = async (time?: any, date?: any): Promise<boolean> => {
  const { to: toF, cc_email, ...values } = await sendMailForm.validateFields()

  if (
   (isSelectAll !== true && toF?.length === 0) ||
   (proLeadsSelectAll?.selectAll && toF?.length === 0)
  ) {
   globalToaster({
    type: 'error',
    content: 'Add at least one recipient',
   })
   return false
  }
  if (
   totalAttachmentMb(values?.temp_attachment) +
    totalAttachmentMb(values?.attachment) >
   10
  ) {
   globalToaster({
    type: 'error',
    content:
     'File Size Exceeded! The size of attachments (single or together) should be less than 10 MB',
   })
   return false
  }
  if (mode === 'EDIT-SHEDULE-MAIL') {
   const formData = new FormData()

   const removedTo = (editData?.to as any)?.filter(
    (i: any) => !toF?.includes(i),
   )

   const newTo = (toF as any)?.filter(
    (item: any) => !editData?.to?.includes(item),
   )

   // const fileAttachment = attachmentFile
   //  ?.filter((i) => editData?.attachment?.includes(i?.url))
   //  ?.map((i) => i?.url)

   // const attachments = attachmentFile?.filter?.(
   //  (i) => !editData?.attachment?.includes(i?.url),
   // )

   if ((removedTo?.length ?? 0) > 0) {
    formData.append('removed_to', removedTo)
   }

   if ((newTo?.length ?? 0) > 0) {
    formData.append('new_to', newTo)
   }

   formData.append('date', date)
   formData.append('time', time)
   formData.append('body', values?.body ?? '')
   formData.append('subject', values?.subject ?? '')
   if (
    (cc_email?.length ?? 0) > 0 &&
    (Array.isArray(watch?.to) ? (watch?.to?.length ?? 0) < 2 : watch?.to) &&
    showCcInput
   ) {
    formData.append('cc_email', JSON.stringify(cc_email ?? []))
   }

   if (templateData?.id) {
    formData.append('temp_id', templateData?.id)
   }
   // if (fileAttachment?.length > 0) {
   //  fileAttachment?.forEach((i, n) => {
   //   formData.append(`file_attachment[${n}]`, i ?? '')
   //  })
   // }

   // if (values?.attachment?.length) {
   //  values?.attachment?.forEach?.((i, n) => {
   //   formData.append(`attachment[${n}]`, i?.originFileObj as any)
   //  })
   // }
   // if (values?.temp_attachment?.length) {
   //  values?.temp_attachment?.forEach?.((i: any, n) => {
   //   formData.append(`temp_attachment[${n}][path]`, i?.path)
   //   formData.append(`temp_attachment[${n}][size]`, i?.size)
   //  })
   // }

   const att = [
    ...(values?.attachment ?? []),
    ...(values?.temp_attachment ?? []),
   ]

   let attachmentIndex = 0
   let tempAttachmentIndex = 0
   if (att?.length) {
    att.forEach((i: any) => {
     if (i.originFileObj) {
      formData.append(`attachment[${attachmentIndex}]`, i.originFileObj as any)
      attachmentIndex++
     } else {
      formData.append(`temp_attachment[${tempAttachmentIndex}][path]`, i.path)
      formData.append(`temp_attachment[${tempAttachmentIndex}][size]`, i.size)
      tempAttachmentIndex++
     }
    })
   }

   await updateEmailSchedule({
    id: editData?.id,
    data: formData,
   }).unwrap()
   // queryClient.invalidateQueries('inbox-scheduled-email')
   d(inboxApi.util.invalidateTags(['SCHEDULE-EMAIL-PREVIEW']))
   if (inboxRefetchKey) {
    queryClient.invalidateQueries(inboxRefetchKey)
   }
   onSuccessEmail?.()
   return true
  }
  const formData = convert2FormDataEmail({
   ...values,
   ...((!isSelectAll && widgetFrom !== 'listing') ||
   (widgetFrom === 'listing' && !proLeadsSelectAll?.selectAll) ||
   (selectAll && !showMoreLabel) ||
   (isSelectAll && !showMoreLabel) ||
   (proLeadsSelectAll?.selectAll && !proLeadsSelectAll?.showMoreLabel)
    ? {
       to: valueToField,
      }
    : {}),
   //  attachment: attachmentFile,
   ...(propFullInfo && propFullInfo.length > 0
    ? {
       property: propFullInfo?.map((i) => ({
        id: i?.slug,
        type: i?.listing_type,
       })),
       listing_type: proListingType,
      }
    : {}),
   ...(time || date ? { time, date } : {}),
   type,
   ...(propFullInfo ? { prop_full_info: propFullInfo } : {}),
   temp_id: templateData?.id,
   ...(selectAll && showMoreLabel ? { select_all: selectAll } : {}),
   ...(proLeadsSelectAll?.selectAll && proLeadsSelectAll?.showMoreLabel
    ? { select_all: proLeadsSelectAll?.selectAll }
    : {}),
   ...(customtSelectAll && showMoreLabel ? { customtSelectAll } : {}),
   ...(unSelected && isSelectAll && showMoreLabel
    ? { unselected: unSelected }
    : {}),
   ...(proLeadsSelectAll?.unSelected &&
   proLeadsSelectAll?.selectAll &&
   proLeadsSelectAll?.showMoreLabel
    ? { unselected: proLeadsSelectAll?.unSelectedId }
    : {}),
   ...(filterInfo && isSelectAll && showMoreLabel
    ? { filter_info: filterInfo }
    : {}),
   ...((cc_email?.length ?? 0) > 0 &&
   (Array.isArray(watch?.to) ? (watch?.to?.length ?? 0) < 2 : watch?.to) &&
   showCcInput
    ? { cc_email: JSON.stringify(cc_email ?? []) as any }
    : {}),
   ...(proLeadsSelectAll?.filterInfo &&
   proLeadsSelectAll?.selectAll &&
   proLeadsSelectAll?.showMoreLabel
    ? { filter_info: proLeadsSelectAll?.filterInfo }
    : {}),
   ...extraBody,
  })

  const handleEmailResponse = (response: any) => {
   if (response?.status === 'success') {
    if (response?.data?.limit_reached) {
     return {
      limitReached: true,
      message: response?.message,
      isError: false,
     }
    }
    globalToaster({ type: 'success', content: response?.message })
    return { limitReached: false, isError: false }
   }
   return { limitReached: false, isError: true }
  }

  let response
  try {
   if (propFullInfo && propFullInfo?.length > 0) {
    response =
     time || date
      ? await SendScheduleEmailPro(formData).unwrap()
      : await sendlistingEmail(formData).unwrap()
   } else if (time || date) {
    response = await scheduleEmail(formData).unwrap()
   } else {
    response = await sendEmail(formData).unwrap()
   }
   const result = handleEmailResponse(response)

   if (result?.limitReached) {
    setLimitReached(result as TLimitReached)
    return false
   }
   if (!result?.isError) {
    if (time || date) {
     const scheduleId = (response as any)?.data?.id
     if (scheduleId) {
      let dataset: any = null
      try {
       const fetchResult = await getScheduleEmailById({ id: scheduleId })
       dataset = fetchResult?.data
      } catch {
       // fall through to local form data
      }
      updateSendEmailWidget({
       show: true,
       mode: 'EDIT-SHEDULE-MAIL',
       to: dataset?.email_to ?? (toF as string | string[]),
       editData: {
        id: dataset?.id ?? scheduleId,
        subject: dataset?.subject ?? values?.subject,
        body: dataset?.body ?? values?.body,
        to: dataset?.email_to ?? (toF as string | string[]),
        date: dataset?.date ?? date,
        time: dataset?.time ?? time,
        attachment: dataset?.attachment,
        cc_email: dataset?.cc_email ?? (cc_email as string[]),
       },
       hideAttachment: dataset?.scheduled_from === 'listing',
      })
     }
     return true
    }
    onSendSuccess?.()
    onSuccessEmail?.()
    return true
   }
   return false
  } catch (error) {
   console.error('Email send failed', error)
   return false
  }

  return false
 }

 useEffect(() => {
  if (widgetFrom === 'listing' && (propFullInfo?.length ?? 0) > 0) {
   const isSingle = propFullInfo?.length === 1
   if (proListingType === 'brokerage') {
    const types = propFullInfo?.map((item) => item?.listing_type)
    const isSameType = types?.every((item) => item === types[0])
    if (isSameType) {
     const val = { single: isSingle, type: types?.[0] as any }
     sendMailForm.setFieldsValue({
      body: setProPreLoadContent({
       ...val,
       conte: listing_mail_content,
      }),
      subject: setProPreLoadContent({
       ...val,
       conte: listing_mail_subject,
      }),
     })
    } else {
     sendMailForm.setFieldsValue({
      body: listing_mail_content?.common,
      subject: listing_mail_subject?.common,
     })
    }
   } else {
    if (
     !(proListingType === 'preconstruction' && (propFullInfo?.length ?? 0) < 2)
    ) {
     sendMailForm.setFieldsValue({
      body: setProPreLoadContent({
       conte: global?.listing_mail_content,
       single: isSingle,
       type: proListingType,
       showPreConSingle: false,
      }),
     })
    }
    sendMailForm.setFieldsValue({
     subject: setProPreLoadContent({
      conte: global?.listing_mail_subject,
      single: isSingle,
      type: proListingType,
     }),
    })
   }
  }
 }, [propFullInfo])

 useEffect(() => {
  if (templateData) {
   sendMailForm.setFieldsValue({
    subject: templateData.subject ?? '',
    body: `${templateData.body ?? ''}`,
    // attachment: convetUrl2FileList(templateData.attachment),
    temp_attachment: templateData?.attachment,
    attachment: [],
   })
  }
 }, [templateData])

 useEffect(() => {
  if (
   (!propFullInfo || (propFullInfo && propFullInfo.length === 0)) &&
   sign &&
   editData === undefined
  ) {
   const editorContent = sendMailForm.getFieldValue('body')
   sendMailForm.setFieldsValue({
    body: handleSignatureContent({ editorContent, sign }),
   })
  }
 }, [sign])

 // Apply caller-provided subject/body, keeping the user's signature appended
 useEffect(() => {
  if (prefill) {
   sendMailForm.setFieldsValue({
    subject: prefill.subject ?? '',
    body: sign
     ? handleSignatureContent({ editorContent: prefill.body ?? '', sign })
     : prefill.body ?? '',
   })
   // One-shot: clear so a later compose doesn't reuse this content
   updateSendEmailWidget({ prefill: undefined })
  }
 }, [prefill])

 useEffect(() => {
  if (to && mode !== 'FORWARD') {
   sendMailForm.setFieldsValue({
    to,
   })
  }
 }, [to])

 useEffect(() => {
  if (mode === 'FORWARD') {
   setShowCcInput(false)
  }
  if (replyData && mode === 'REPLY') {
   sendMailForm.setFieldsValue({
    subject: `${replyData.subject}`,
    // attachment: convetUrl2FileList(replyData?.attachment),
    to: replyData?.to,
    cc_email: replyData?.cc_email,
   })
   //  setAttachmentFile(convetUrl2FileList(replyData?.attachment))
  } else if (mode === 'FORWARD' && forwardData) {
   sendMailForm.setFieldsValue({
    subject: `${forwardData.subject}`,
    // attachment: convetUrl2FileList(forwardData.attachment),
    temp_attachment: forwardData?.attachment,
   })
   //  setAttachmentFile(convetUrl2FileList(forwardData.attachment))
  } else if (mode === 'EDIT-SHEDULE-MAIL' && editData) {
   sendMailForm.setFieldsValue({
    subject: `${editData.subject}`,
    body: `${editData?.body}`,
    cc_email: editData?.cc_email,
    // attachment: convetUrl2FileList(editData?.attachment),
    attachment: editData?.attachment,
   })
   //  setAttachmentFile(convetUrl2FileList(editData?.attachment))
  }
  return () => {
   sendMailForm.resetFields()
  }
 }, [mode, forwardData, replyData, editData])

 const toFieldValue = useMemo(() => {
  if (type === 'lead') {
   return Array.isArray(watch?.to)
    ? { to: watch?.to?.join(',') ?? [] }
    : { to: watch?.to }
  }
  return {
   to: (watch?.to as [])?.map((i: any) => i?.id)?.join(',') ?? [],
  }
 }, [type, watch])

 const attachments = sendMailForm.getFieldValue('attachment')
 const tempAttachments = sendMailForm.getFieldValue('temp_attachment')
 const ccMailValue = sendMailForm.getFieldValue('cc_email')

 return (
  <SendWidgetLayout
   type={sendWidget?.type}
   proData={sendWidget?.propFullInfo}
   onUpdateProData={(val: any) => {
    updateSendEmailWidget({ propFullInfo: val })
   }}
   loading={isLoading || isFetching}
   onSchedule={(time, date) => handleClickSend(time, date)}
   scheduleLoading={
    SendScheduleEmailProLoading ||
    sendScheduleEmailLoading ||
    emailScheduleLoading
   }
   submitLoading={
    ListEmailLoading ||
    sendEmailLoading ||
    emailScheduleLoading ||
    SendScheduleEmailProLoading ||
    sendScheduleEmailLoading
   }
   onSend={() => handleClickSend()}
   productCount={productCount}
   attachment={{
    // count: attachmentCount,
    onChange: (v) => sendMailForm.setFieldsValue({ attachment: v }),
    // value: attachmentFile,
    value: attachments,
   }}
   previewData={{
    body: watch?.body,
    subject: watch?.subject,
    from: user?.twilio_email,
    type,
    ...(propFullInfo && widgetFrom === 'listing'
     ? { prop_full_info: propFullInfo }
     : {}),
    ...(propFullInfo && propFullInfo?.length > 0 && widgetFrom === 'listing'
     ? {
        listing_type: proListingType,
        property: JSON.stringify(
         propFullInfo?.map((i) => ({
          id: i?.slug,
          type: i?.listing_type,
         })),
        ),
       }
     : {}),
    ...toFieldValue,
    ...((watch?.to?.length ?? 0) < 2 ? { cc_email: watch?.cc_email } : {}),
   }}
   widgetFrom={widgetFrom}
   from="Email"
   handleValidation={() => {
    if (
     !toFieldValue?.to ||
     (toFieldValue?.to && toFieldValue?.to.length === 0)
    ) {
     globalToaster({ type: 'error', content: 'Enter To Input' })
     return false
    }
    if (!watch?.subject) {
     globalToaster({ type: 'error', content: 'Enter Subject' })
     return false
    }
    if (watch?.subject?.length < 3) {
     globalToaster({
      type: 'error',
      content: 'Subject must be at least 3 characters.',
     })
     return false
    }
    if (watch?.subject?.length > 191) {
     globalToaster({
      type: 'error',
      content: 'Subject cannot exceed 191 characters.',
     })
     return false
    }
    return true
   }}
   hideAttachment={hideAttachment}
   mode={mode}
   editData={editData}
  >
   <div className="sw-form-section">
    <Form initialValues={initialValues} form={sendMailForm}>
     <Form.Item name="from" label="From">
      <Input readOnly />
     </Form.Item>

     <FormItem label="To" name="to">
      {type === 'tag' || type === 'stage' || type === 'source' ? (
       <SWToBarTag type="email" forType={type} />
      ) : (
       <SWToBar
        type="email"
        proLeadsSelectAll={proLeadsSelectAll}
        setProLeadsSelectAll={setProLeadsSelectAll}
        ccMailValue={ccMailValue}
        onConfirmShowModal={() => sendMailForm.setFieldsValue({ cc_email: [] })}
       />
      )}
     </FormItem>
     {(!Array.isArray(watch?.to) ||
      (Array.isArray(watch?.to) && (watch?.to?.length ?? 0) < 2)) &&
      type === 'lead' && (
       <FormItem label="Cc" name="cc_email">
        <SWCCInput
         {...(Array.isArray(watch?.to) && watch?.to?.[0]
          ? { toValue: watch?.to?.[0] }
          : watch?.to
          ? { toValue: watch?.to as string }
          : {})}
        />
       </FormItem>
      )}

     <FormItem name="subject">
      <EmailSubjectInput
       mergeField={mode !== 'REPLY'}
       readOnly={mode === 'REPLY'}
      />
     </FormItem>
     {proListingType === 'preconstruction' && propFullInfo?.length === 1 ? (
      <div className="d-flex align-items-center justify-content-center w-100 mt-5">
       <p style={{ fontSize: '15px', fontWeight: '500' }}>
        Note: The Pre-con single listing emails will be shared as a pre-designed
        template. The compose option will not be available for such emails.
        Please use the preview option to view the template
       </p>
      </div>
     ) : (
      <>
       <FormItem
        name="body"
        className={`sw-texteditor ${
         [...(attachments ?? []), ...(tempAttachments ?? [])]?.length
          ? 'have-attachments'
          : ''
        }`}
       >
        <EmailTextEditor
         emailTemplate={widgetFrom !== 'listing'}
         onSelectTemplate={(id) => setTemplateId(id)}
         onChangeSignatue={(v) => {
          setSign(v ?? '')
         }}
         showSignatureBtn={
          (!propFullInfo || (propFullInfo && propFullInfo.length === 0)) &&
          editData === undefined
         }
         selectedSign={selectedSign}
         setSelectedSign={setSelectedSign}
        />
       </FormItem>
       <FormItem name="temp_attachment" noStyle>
        {null}
       </FormItem>
       <FormItem name="attachment" noStyle>
        {null}
       </FormItem>
       {[...(attachments ?? []), ...(tempAttachments ?? [])]?.length > 0 && (
        <EmailAttachmentsPopver
         onUpdate={(att_mode, value) => {
          sendMailForm.setFieldsValue({ [att_mode]: value })
         }}
         attachments={attachments ?? []}
         tempAttachments={tempAttachments ?? []}
         isEditMode={mode === 'EDIT-SHEDULE-MAIL'}
        />
       )}
      </>
     )}
    </Form>
   </div>
   {limitReached?.limitReached && (
    <InsufficientCredits
     message={limitReached?.message}
     visible={limitReached?.limitReached}
     onCancel={() => {
      setLimitReached(null)
     }}
     onSuccess={() => {
      setLimitReached(null)
     }}
     creditType="email"
    />
   )}
  </SendWidgetLayout>
 )
}

export default EmailSendWidget
